"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeRedirectError = exports.isRedirectToLoginError = exports.getAdabyronURL_API = exports.getAdabyronConstants = void 0;
const next_utils_constants_1 = require("@gerenciatd/next.utils.constants");
const next_utils_environment_1 = require("@gerenciatd/next.utils.environment");
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
/**
 * Devuelve el processName y prefix
 * @param {string} userType -> Puede ser Telco o ''
 * @returns {object} processName y prefixToApply
 */
const getAdabyronConstants = (userType) => {
    let processName = next_utils_constants_1.PROCESS_NAME.OPEN;
    let prefixToApply = next_utils_constants_1.PREFIX_TO_APPLY.OPEN;
    if (userType && userType === 'Telco') {
        processName = next_utils_constants_1.PROCESS_NAME.CLIENT;
        prefixToApply = next_utils_constants_1.PREFIX_TO_APPLY.CLIENT;
    }
    return { processName, prefixToApply };
};
exports.getAdabyronConstants = getAdabyronConstants;
/**
 * Devuelve el processName y prefix
 * @param {string} path -> URL inicial
 * @param {string} version -> Version de api de TELCO
 * @param {string} idRequest
 * @param {string} host
 * @param {string} prefixToApply
 * @param {string} queryParams -> Parametros a concatenar en la url
 * @param {string} urlParamsToReplace -> Parametros a sustituir en la url
 * @returns {object} URL a la que hacer la request
 */
const getAdabyronURL_API = ({ path, version, idRequest, host, prefixToApply, queryParams, urlParamsToReplace }) => {
    const pathBegin = path.substring(0, path.indexOf('/'));
    const pathEnd = path.substring(path.indexOf('/') + 1, path.length);
    let finalEndpoint = `${host}${prefixToApply}${pathBegin}/`;
    if (version) {
        finalEndpoint = `${finalEndpoint}v${version}/`;
    }
    finalEndpoint = `${finalEndpoint}${pathEnd}?${idRequest}`;
    if (queryParams && Array.isArray(queryParams) && queryParams.length > 0) {
        for (const queryParam of queryParams) {
            const { param, value } = queryParam;
            if (param) {
                if (!Object.prototype.hasOwnProperty.call(queryParam, 'value')) {
                    finalEndpoint += `&${param}`;
                }
                else if (value !== undefined) {
                    finalEndpoint += `&${param}=${String(value)}`;
                }
            }
        }
    }
    if (urlParamsToReplace && Array.isArray(urlParamsToReplace) && urlParamsToReplace.length > 0) {
        urlParamsToReplace.forEach((paramToReplace) => {
            const { param, value } = paramToReplace;
            finalEndpoint = finalEndpoint.replace(param, String(value));
        });
    }
    return finalEndpoint;
};
exports.getAdabyronURL_API = getAdabyronURL_API;
const isRedirectToLoginError = (responseUrl) => {
    if (responseUrl && responseUrl.indexOf('DesafioUnico') !== -1) {
        return true;
    }
    return false;
};
exports.isRedirectToLoginError = isRedirectToLoginError;
const normalizeRedirectError = (responseUrl) => {
    let urlRedirect = "/";
    if ((0, next_utils_common_1.isFrontApp)()) {
        const urlActual = window.location.href;
        const urlOrigin = window.location.origin;
        const urlString = `mimovistar-cliente/publico/servicio/login?urlContenedora=${responseUrl}&urlDestino=${encodeURIComponent(urlActual)}`;
        const urlsValidate = [next_utils_environment_1.TELCO_ENVS.PROD.endpoint, next_utils_environment_1.TELCO_ENVS.CERT.endpoint, next_utils_environment_1.TELCO_ENVS.INTE.endpoint];
        if (urlsValidate.indexOf(urlOrigin) !== -1) {
            urlRedirect = `${urlOrigin}/${urlString}`;
        }
    }
    return urlRedirect;
};
exports.normalizeRedirectError = normalizeRedirectError;
//# sourceMappingURL=index.js.map